<template>
  <h2 class="form-title">Create FAQ</h2>
  <VeeForm class="table-shadow faq-form" @submit="createFAQ">
    <Field v-slot="{ field, errors, meta }" name="question" :rules="rules.question">
      <div class="form-group">
        <label class="required fs-xl mt-0">Question</label>
        <div class="input-group">
          <input
            v-bind="field"
            v-model="question.question"
            :class="['form-control', getValidationState(meta)]"
            type="text"
            placeholder="Question"
          />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </div>
    </Field>

    <Field v-slot="{ field, errors, meta }" name="answer" :rules="rules.answer">
      <div class="form-group">
        <label class="required fs-xl mt-0">Answer</label>
        <div class="input-group">
          <input
            v-bind="field"
            v-model="question.answer"
            :class="['form-control', getValidationState(meta)]"
            type="text"
            placeholder="Answer"
          />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </div>
    </Field>

    <div class="form-group mt-4 mb-0">
      <button type="submit" class="btn create-btn btn-green">Create new question</button>
    </div>
  </VeeForm>
</template>

<script lang="ts">
import { Form as VeeForm, Field } from 'vee-validate'
import { ref, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { getValidationState } from '@/services/Validation'
import { useFaqStore } from '@/store/faq'
import { FAQ_LIST } from '@/types/router'

export default defineComponent({
  name: 'FAQCreate',
  components: { Field, VeeForm },
  setup() {
    const faqStore = useFaqStore()
    const router = useRouter()
    const question = ref({
      question: '',
      answer: '',
    })

    const rules = {
      question: 'required|min:3',
      answer: 'required|min:3',
    }

    const createFAQ = async () => {
      await faqStore.createQuestion(question.value)
      router.push({ name: FAQ_LIST })
    }

    return {
      question,
      rules,
      createFAQ,
      getValidationState,
    }
  },
})
</script>
